import Chart from 'chart.js'
import dateFns from 'date-fns'

export default class ClientsChart {
  constructor() {
    const ctx = document.getElementById('clients-chart').getContext('2d')
    this.chartBubble = new Chart(ctx, {
      type: 'bubble',
      data: {
        labels: [],
        datasets: [
          {
            data: [],
            backgroundColor: 'rgba(42, 10, 78, 1)',
            borderColor: 'rgba(42, 10, 78, 1)',
            hoverBackgroundColor: 'rgba(255, 255, 255, 1)',
            hoverBorderWidth: 5,
            hoverRadius: 3,
            borderWidth: 2,
            hitRadius: 4,
            // fill: 0,
            yAxisID: 'clients'
            // radius: 1
          },
          {
            type: 'scatter',
            data: [],
            // pointStyle: 'rect',
            backgroundColor: '#cccccc',
            borderColor: 'rgba(0, 0, 0, 0)',
            hoverBackgroundColor: '#cccccc',
            hoverBorderColor: 'rgba(0, 0, 0, 0)',
            pointHoverBorderColor: 'rgba(0, 0, 0, 0.3)',
            pointHoverBackgroundColor: '#cccccc',
            pointHoverRadius: 3,
            pointHoverBorderWidth: 1,
            pointHitRadius: 10,
            hitRadius: 0,
            borderWidth: 1,
            fill: 0,
            yAxisID: 'clients',
            radius: 3
          },
          {
            type: 'line',
            data: [],
            showLine: false
          }
        ]
      },
      options: {
        layout: {
          padding: {
            left: 42,
            right: window.innerWidth < 1200 ? 20 : 30
          }
        },
        legend: { display: false },
        tooltips: {
          enabled: false,
          callbacks: { label: tooltipsCallback },
          custom: setToolTip
        },
        maintainAspectRatio: false,
        scales: {
          yAxes: [
            {
              id: 'clients',
              position: 'left',
              display: true,
              ticks: {
                beginAtZero: true,
                min: 0,
                max: 1.99,
                stepSize: 1,
                display: false
              },
              gridLines: {
                display: true,
                drawBorder: false,
                zeroLineColor: 'rgba(0, 0, 0, 0)'
              },
              afterBuildTicks: axis => {
                axis.ticks = []
                axis.ticks.push(0)
                axis.ticks.push(1)
                // this.chartBubble.ticks.push(100);
              }
            }
          ],
          xAxes: [
            {
              id: 'xFum',
              barThickness: 5,
              gridLines: {
                display: false,
                drawBorder: false
              },
              ticks: {
                padding: 0,
                display: false
              }
            }
          ]
        }
      }
    })
  }

  updateClientsData(data, portfoliodata = []) {
    const newClients = data.map((x, i) => {
      if (i === 0) {
        return 0
      } else {
        let newClient = x.new_clients - data[i - 1].new_clients
        if (x.new_clients - data[i - 1].new_clients < 0) {
          newClient = 0
        }
        return newClient
      }
    })

    const newClientsRadius = newClients.map((newClient, i) => {
      let radius = newClient * 2 < 30 ? newClient * 2 : 30
      if (newClient === 0) {
        return { x: Number(i), y: 0, r: 0 }
      }
      return { x: Number(i), y: Number(1), r: Number(radius) }
    })
    const zeroPoints = newClientsRadius.map(x => {
      if (x.r === 0) {
        return {
          x: x.x,
          y: 1
        }
      } else {
        return ''
      }
    })
    this.chartBubble.data.datasets[0].data = newClientsRadius
    this.chartBubble.data.datasets[1].data = zeroPoints
    this.chartBubble.data.datasets[2].data = newClients

    this.chartBubble.options.scales.xAxes[0].ticks.max = newClients.length - 1
    this.chartBubble.update()
  }
}

const tooltipsCallback = (tooltipItem, data) => {
  const index =
    tooltipItem.datasetIndex === undefined
      ? tooltipItem.index
      : tooltipItem.datasetIndex
  const itemData = data.datasets[index]
  // Return custom data to tooltip, these will be available inside the tooltip.body
  return {
    id: data.id,
    datasetIndex: tooltipItem.datasetIndex,
    label: itemData.label,
    value: tooltipItem.yLabel,
    newClients: data.datasets[2].data[tooltipItem.index]
  }
}

const setToolTip = tooltip => {
  // Tooltip Element
  const tooltipEl = document.getElementById('clients-chart-chartjs-tooltip')

  // Hide if no tooltip
  if (tooltip.opacity === 0) {
    tooltipEl.style.opacity = 0
    return
  }

  // Set caret Position
  tooltipEl.classList.remove('above', 'below', 'no-transform')
  if (tooltip.yAlign) {
    tooltipEl.classList.add(tooltip.yAlign)
  } else {
    tooltipEl.classList.add('no-transform')
  }

  function getBody(bodyItem) {
    return bodyItem.lines
  }

  // Set Text
  if (tooltip.body) {
    var bodyLines = tooltip.body.map(getBody)

    let innerHtml = `<div class="tooltip__body">`
    bodyLines.forEach((body, i) => {
      innerHtml += `<div class="tooltip__body--text tooltip__top">`
      innerHtml += `${Number(body[0].newClients)}</div>`

      let offset = 21 - body[0].newClients * 2
      offset = offset < 0 ? 0 : offset
      tooltipEl.style.paddingBottom = offset + 'px'
    })

    innerHtml += `</div>`
    tooltipEl.innerHTML = innerHtml
  }
  tooltipEl.style.opacity = 1
  tooltipEl.style.paddingLeft = tooltip.caretX - 4 + 'px'
}



// WEBPACK FOOTER //
// ./assets/j/src/charts/clients.js